module.exports = __webpack_public_path__ + "fonts/Trade-Gothic-LT.woff";


//////////////////
// WEBPACK FOOTER
// ./Common/fonts/Trade-Gothic-LT.woff
// module id = 21
// module chunks = 0 1 2 3 4 5 6 7